module.exports = __webpack_public_path__ + "static/media/Email_icon.5382dc67.svg";